import { useEffect, useState } from 'react';
import ReactInputVerificationCode from 'react-input-verification-code';
import './confirmation-code-input.scss';

const ConfirmationCodeInput = ({
  autoFocus,
  length,
  onChange,
  onCompleted,
  placeholder,
  defaultValue,
  value,
}) => {
  const [codeValue, setCodeValue] = useState('');
  useEffect(() => {
    if (defaultValue) {
      setCodeValue(defaultValue);
    } else {
      setCodeValue(value);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  return (
    <div className="confirm-code">
      <ReactInputVerificationCode
        autoFocus={autoFocus}
        length={length}
        placeholder={placeholder || ''}
        onChange={onChange}
        onCompleted={onCompleted}
        value={codeValue}
      />
    </div>
  );
};

export default ConfirmationCodeInput;
